import {
  Card,
  Col,
  DatePicker,
  Divider,
  Empty,
  Row,
  Select,
  Skeleton,
  Spin,
  Tooltip,
} from "antd";
import { Column, Liquid, Pie, Gauge, G2, RadialBar } from "@ant-design/plots";
import React from "react";
import { withRouter } from "react-router-dom";
import { axiosInstance } from "../../commons/commons";
import {
  building,
  complaint,
  project,
  transactions,
  unit,
} from "../../constants/url";
import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";
import { stateStore } from "../../constants/constants";
const { registerShape, Util } = G2;

// custom gauge indicator registration
registerShape("point", "custom-gauge-indicator", {
  draw(cfg, container) {
    const { indicator, defaultColor } = cfg.customInfo;
    const { pointer } = indicator;
    const group = container.addGroup();

    const center = this.parsePoint({
      x: 0,
      y: 0,
    });

    if (pointer) {
      const { startAngle, endAngle } = Util.getAngle(cfg, this.coordinate);
      const radius = this.coordinate.getRadius();
      const midAngle = (startAngle + endAngle) / 2;
      const { x: x1, y: y1 } = Util.polarToCartesian(
        center.x,
        center.y,
        radius / 15,
        midAngle + 1 / Math.PI
      );
      const { x: x2, y: y2 } = Util.polarToCartesian(
        center.x,
        center.y,
        radius / 15,
        midAngle - 1 / Math.PI
      );
      const { x, y } = Util.polarToCartesian(
        center.x,
        center.y,
        radius * 0.65,
        midAngle
      );
      const path = [
        ["M", center.x, center.y],
        ["L", x1, y1],
        ["L", x, y],
        ["L", x2, y2],
        ["Z"],
      ]; // pointer

      group.addShape("path", {
        name: "pointer",
        attrs: {
          path,
          fill: defaultColor,
          ...pointer.style,
        },
      });
    }

    return group;
  },
});

class EmployeeHome extends React.Component {
  _isMounted = false;
  state = {
    dateFormat: "YYYY-MM-DD",
    loadingData: true,
    complaintData: {
      dateRange: [moment(), moment()],
      viewBy: "read",
      list: [],
      visualizationData: [],
      solvedPercent: 0,
      solvedRatio: 0,
      noOfSolvedComplaints: 0,
      noOfPendingComplaints: 0,
      noOfPendingHighPriorities: 0,
      noOfAverageDays: 0,
      dataIsLoading: true,
    },
    unitData: {
      list: [],
      visualizationData: [],
      dataIsLoading: true,
    },
    incomeData: {
      entityList: [],
      icon: <LoadingOutlined />,
      selectedValue: null,
      dataIsLoading: true,
      entity: "SegmentID3",
      dateRange: [moment(), moment()],
      visualizationData: [],
    },
  };

  getInitialState = async () => {
    let state = {
      dateFormat: "YYYY-MM",
      loadingData: false,
      complaintData: {
        dateRange: [moment(new Date().getFullYear() + "-01-01")],
        viewBy: "read",
        list: [],
        visualizationData: [],
        solvedPercent: 0,
        solvedRatio: 0,
        noOfSolvedComplaints: 0,
        noOfPendingComplaints: 0,
        noOfPendingHighPriorities: 0,
        noOfAverageDays: 0,
        dataIsLoading: false,
      },
      unitData: {
        list: [],
        visualizationData: [],
        dataIsLoading: false,
      },
      incomeData: {
        entityList: [],
        icon: null,
        selectedValue: null,
        dataIsLoading: false,
        entity: "SegmentID3",
        dateRange: [],
        visualizationData: [],
      },
    };
    await axiosInstance
      .get(complaint + "?dashboard=true")
      .then((res) => {
        if (res.data.success) {
          state.complaintData.list = res.data.message.rows;
        }
      })
      .catch(() => {});
    // await axiosInstance
    //   .get(unit + "?dashboard=true")
    //   .then((res) => {
    //     if (res.data.success) {
    //       let data = { Rented: 0, Vacant: 0 };
    //       state.incomeData.entityList = res.data.message.map((unit, index) => {
    //         // select first unit to retrieve its data by default
    //         if (index === 0) state.incomeData.selectedValue = unit.SegmentId;
    //         if (
    //           ((unit.RentalUnitSubStatus || {}).UserName || "")
    //             .toLowerCase()
    //             .indexOf("rent") !== -1
    //         )
    //           data.Rented += 1;
    //         else data.Vacant += 1;
    //         return unit;
    //       });
    //       state.unitData.list = res.data.message;
    //       state.unitData.visualizationData.push({
    //         type: "Rented",
    //         value: data.Rented,
    //       });
    //       state.unitData.visualizationData.push({
    //         type: "Vacant",
    //         value: data.Vacant,
    //       });
    //     }
    //   })
    //   .catch(() => {});

    return state;
  };

  complaintOnChange = () => {
    let state = this.state;
    state.complaintData.dataIsLoading = true;
    this.setState(state);
    let data = {},
      closedComplaints = 0,
      averageDaysEncounters = 0;
    state.complaintData.visualizationData = [];
    state.complaintData.solvedPercent = 0;
    state.complaintData.solvedRatio = 0;
    state.complaintData.noOfSolvedComplaints = 0;
    state.complaintData.noOfPendingComplaints = 0;
    state.complaintData.noOfPendingHighPriorities = 0;
    state.complaintData.noOfAverageDays = 0;
    for (let complaint of state.complaintData.list) {
      complaint.date = complaint.ComplaintDate.split("-").slice(0, 2).join("-");
      if (state.complaintData.dateRange[0]) {
        if (
          state.complaintData.dateRange[0]
            .toISOString()
            .split("-")
            .slice(0, 2)
            .join("-") > complaint.date
        )
          continue; // donot process data
      }
      if (state.complaintData.dateRange[1])
        if (
          state.complaintData.dateRange[1]
            .toISOString()
            .split("-")
            .slice(0, 2)
            .join("-") < complaint.date
        )
          continue; // donot process data
      /**
       * begin processing visualization data
       */
      if (!data[complaint.date])
        data[complaint.date] = {
          priority: {},
          status: {
            Open: { label: "Open", value: 0 },
            Closed: { label: "Closed", value: 0 },
          },
          read: {
            Read: { label: "Read", value: 0 },
            Unread: { label: "Unread", value: 0 },
          },
          building: {},
          technician: {},
          complaintType: {},
          open: 0, // for solve ratio (gauge)
          closed: 0, // for solve ratio (gauge)
        };
      if (
        // for solve ratio
        complaint.OpenClosed &&
        complaint.OpenClosed.toLowerCase().indexOf("open") !== -1
      ) {
        data[complaint.date].open += 1;
        if ((complaint.Priority || "").toLowerCase() === "critical")
          state.complaintData.noOfPendingHighPriorities += 1;
      }
      // if status doesnot exist then it is marked as closed
      else {
        data[complaint.date].closed += 1;
        if (complaint.DateEdited) {
          averageDaysEncounters += 1;
          state.complaintData.noOfAverageDays +=
            (new Date(complaint.DateEdited) -
              new Date(complaint.ComplaintDate)) /
            86400000;
        }
      }
      switch (state.complaintData.viewBy) {
        // begin for priority
        case "priority":
          if (complaint.Priority) {
            if (!data[complaint.date].priority[complaint.Priority])
              data[complaint.date].priority[complaint.Priority] = {
                value: 0,
                label: complaint.Priority,
              };
            data[complaint.date].priority[complaint.Priority].value += 1;
          }
          break;
        case "status":
          if (
            complaint.OpenClosed &&
            complaint.OpenClosed.toLowerCase().indexOf("open") !== -1
          )
            data[complaint.date].status.Open.value += 1;
          // if status is doesnot exist then it is marked as closed
          else data[complaint.date].status.Closed.value += 1;
          break;
        /**
         * begin for read.
         * Viewed column in database is created way later which lead to null
         * data in previous data. so if the Viewed is false, then the complaint
         * is created by this webapp and is not viewed. Viewed=true or null
         * means the complaint(s) are read.
         */
        case "read":
          if (complaint.Viewed === false)
            data[complaint.date].read.Unread.value += 1;
          else data[complaint.date].read.Read.value += 1;
          break;
        // begin for building
        case "building": {
          if ((complaint.Building || {}).BuildingID) {
            if (
              !data[complaint.date].building[
                String((complaint.Building || {}).BuildingID)
              ]
            )
              data[complaint.date].building[
                String((complaint.Building || {}).BuildingID)
              ] = {
                value: 0,
                label: (complaint.Building || {}).BuildingName || "General",
              };
            data[complaint.date].building[
              String((complaint.Building || {}).BuildingID)
            ].value += 1;
          }
          break;
        }
        case "technician": {
          if ((complaint.Supervisor || {}).ContactID) {
            if (
              !data[complaint.date].technician[
                String((complaint.Supervisor || {}).ContactID)
              ]
            )
              data[complaint.date].technician[
                String((complaint.Supervisor || {}).ContactID)
              ] = { value: 0, label: (complaint.Supervisor || {}).ContactName };
            data[complaint.date].technician[
              String((complaint.Supervisor || {}).ContactID)
            ].value += 1;
          }
          break;
        }
        case "complaintType": {
          if ((complaint.ComplaintType || {}).ComplaintTypeID) {
            if (
              !data[complaint.date].complaintType[
                String((complaint.ComplaintType || {}).ComplaintTypeID)
              ]
            )
              data[complaint.date].complaintType[
                String((complaint.ComplaintType || {}).ComplaintTypeID)
              ] = { value: 0, label: (complaint.ComplaintType || {}).UserName };
            data[complaint.date].complaintType[
              String((complaint.ComplaintType || {}).ComplaintTypeID)
            ].value += 1;
          }
          break;
        }
        default:
          break;
      }
      if (
        !complaint.OpenClosed ||
        complaint.OpenClosed.toLowerCase().indexOf("close") !== -1
      )
        closedComplaints += 1;
    }
    Object.keys(data).map((date) => {
      Object.keys(data[date]).map((category) =>
        Object.keys(data[date][category]).map((id) => {
          id = String(id);
          if (data[date][category][id].value)
            state.complaintData.visualizationData.push({
              date: date,
              category: category,
              subCategory: data[date][category][id].label,
              id: id,
              value: data[date][category][id].value,
            });
          return id;
        })
      );
      state.complaintData.noOfSolvedComplaints += data[date].closed;
      state.complaintData.noOfPendingComplaints += data[date].open;
      return date;
    });
    state.complaintData.dataIsLoading = false;
    if (
      state.complaintData.noOfPendingComplaints +
      state.complaintData.noOfSolvedComplaints
    )
      // avoid dividing by zero
      state.complaintData.solvedPercent =
        (closedComplaints /
          (state.complaintData.noOfPendingComplaints +
            state.complaintData.noOfSolvedComplaints)) *
        100;
    state.complaintData.solvedRatio =
      state.complaintData.solvedPercent / Object.keys(data).length;
    if (averageDaysEncounters)
      state.complaintData.noOfAverageDays =
        state.complaintData.noOfAverageDays / averageDaysEncounters;
    stateStore.employeeHome = state;
    this.setState(state);
  };

  incomeOnChange = () => {
    let state = this.state;
    state.incomeData.dataIsLoading = true;
    this.setState(state);
    state.incomeData.dataIsLoading = false;
    axiosInstance
      .post(transactions, {
        acc_types: ["IN", "EX"],
        dates: this.state.incomeData.dateRange.map(
          (date) => date.toISOString().split("T")[0]
        ),
        [state.incomeData.entity]: this.state.incomeData.selectedValue,
      })
      .then((res) => {
        if (res.data.success) {
          state = this.state;
          state.incomeData.visualizationData = [];
          let monthMap = {
            "01": "Jan",
            "02": "Feb",
            "03": "Mar",
            "04": "Apr",
            "05": "May",
            "06": "Jun",
            "07": "Jul",
            "08": "Aug",
            "09": "Sep",
            10: "Oct",
            11: "Nov",
            12: "Dec",
          };
          let data = {},
            dateViewByMonth =
              this.state.incomeData.dateRange.length === 2 &&
              this.state.incomeData.dateRange[0].toISOString().split("-")[0] ===
                this.state.incomeData.dateRange[1].toISOString().split("-")[0];
          for (let row of res.data.message) {
            row.year = row.TransDate.split("-");
            row.month = row.year[1];
            row.year = row.year[0];
            // for view by year
            if (!data[row.year]) data[row.year] = { income: 0, expense: 0 };
            if (row.AccNo.indexOf("IN") !== -1)
              data[row.year].income += row.Tr_Credit - row.Tr_Debit;
            else data[row.year].expense += row.Tr_Debit - row.Tr_Credit;
            /**
             * populate month wise data if dateRange are of the same year
             */
            if (dateViewByMonth)
              for (let month of Object.keys(monthMap)) {
                if (row.month === month && (row.Tr_Debit || row.Tr_Credit))
                  // only allow negative or positive but zero
                  state.incomeData.visualizationData.push({
                    type: row.AccNo.indexOf("IN") !== -1 ? "income" : "expense",
                    month: monthMap[month],
                    monthDigit: row.month,
                    total: Number(
                      (row.AccNo.indexOf("IN") !== -1
                        ? row.Tr_Credit
                        : row.Tr_Debit
                      ).toFixed(2)
                    ),
                  });
              }
          }
          if (
            // view by year (dateRanges between various years)
            !dateViewByMonth
          ) {
            Object.keys(data).map((year) => {
              if (data[year].income)
                state.incomeData.visualizationData.push({
                  type: "income",
                  year: year,
                  total: Number(data[year].income.toFixed(2)),
                });
              return year;
            });
            Object.keys(data).map((year) => {
              if (data[year].expense)
                state.incomeData.visualizationData.push({
                  type: "expense",
                  year: year,
                  total: Number(data[year].expense.toFixed(2)),
                });
              return year;
            });
          }
        }
        stateStore.employeeHome = state;
        this.setState(state);
      })
      .catch(() => {
        this.setState(state);
      });
  };

  componentDidMount() {
    this._isMounted = true;
    if (stateStore.employeeHome) this.setState(stateStore.employeeHome);
    else
      this.getInitialState().then((state) => {
        if (this._isMounted) {
          stateStore.employeeHome = state;
          this.setState(state, () => {
            this.complaintOnChange();
            this.incomeOnChange();
          });
        }
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <Spin
        spinning={false}
        // spinning={this.state.loadingData}
        tip="fetching and populating data..."
        style={{ marginTop: window.innerHeight / 4 }}
      >
        <Row gutter={[40, 32]} style={{ padding: 20 }}>
          <Col span={24}>
            <Divider
              style={{
                margin: 0,
                visibility: !this.state.complaintData.list.length
                  ? "hidden"
                  : null,
              }}
            >
              Complaint
            </Divider>
          </Col>
          <Col span={8} xs={24} sm={24} md={12} lg={12}>
            {this.state.complaintData.dataIsLoading &&
            !this.state.complaintData.visualizationData.length ? (
              <Skeleton.Button
                active
                style={{
                  // width: window.innerWidth / 3 - 40,
                  width:
                    window.outerWidth >= 992
                      ? window.innerWidth / 2 - 60
                      : window.outerWidth >= 768
                      ? window.innerWidth / 2 - 50
                      : window.innerWidth - 90,
                  height: (window.innerHeight - 50) / 2,
                  // borderRadius: 20,
                }}
              />
            ) : this.state.complaintData.list.length ? (
              <Card
                style={{
                  width: "100%",
                  // height: "100px",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  // borderRadius: 20,
                }}
                headStyle={{
                  textAlign: "center",
                  height: "30px",
                  minHeight: "30px",
                  padding: 0,
                }}
                bodyStyle={{
                  padding: 10,
                  paddingBottom: 0,
                  borderBottom: "0px solid",
                  textAlign: "center",
                  minHeight: 200,
                }}
                title={
                  <Row>
                    <Col span={12} xs={12} sm={12} md={12} lg={12}>
                      <Tooltip title="Date range">
                        <DatePicker.RangePicker
                          allowClear
                          allowEmpty={[true, true]}
                          showTime={false}
                          format={this.state.dateFormat}
                          ranges={{
                            Today: [moment(), moment()],
                            "This Month": [
                              moment().startOf("month"),
                              moment().endOf("month"),
                            ],
                          }}
                          style={{
                            width: "100%",
                            // borderTopLeftRadius: 20,
                            // borderTopRightRadius: 20,
                          }}
                          onChange={(val, dateString) => {
                            let state = this.state;
                            state.complaintData.dateRange = val || [];
                            this.setState(state, this.complaintOnChange);
                          }}
                          value={this.state.complaintData.dateRange}
                        ></DatePicker.RangePicker>
                      </Tooltip>
                    </Col>
                    <Col span={12} xs={12} sm={12} md={12} lg={12}>
                      <Tooltip title="View by">
                        <Select
                          style={{
                            width: "100%",
                            // borderTopLeftRadius: 20,
                            // borderTopRightRadius: 20,
                          }}
                          placeholder="View by"
                          onChange={(val) => {
                            let state = this.state;
                            state.complaintData.viewBy = val;
                            this.setState(state, this.complaintOnChange);
                          }}
                          value={this.state.complaintData.viewBy}
                        >
                          <Select.Option key={0} value={"priority"}>
                            Priority
                          </Select.Option>
                          <Select.Option key={1} value={"status"}>
                            Status
                          </Select.Option>
                          <Select.Option key={2} value={"read"}>
                            Read
                          </Select.Option>
                          <Select.Option key={3} value={"building"}>
                            Building
                          </Select.Option>
                          <Select.Option key={4} value={"technician"}>
                            Technician
                          </Select.Option>
                          <Select.Option key={5} value={"complaintType"}>
                            Complaint Type
                          </Select.Option>
                        </Select>
                      </Tooltip>
                    </Col>
                  </Row>
                }
              >
                {this.state.complaintData.dataIsLoading ? (
                  <Spin
                    style={{ marginTop: 50 }}
                    spinning={this.state.complaintData.dataIsLoading}
                    tip="fetching data..."
                  ></Spin>
                ) : this.state.complaintData.visualizationData.length ? (
                  <Column
                    {...{
                      data: this.state.complaintData.visualizationData.sort(
                        (a, b) => new Date(a.date) - new Date(b.date)
                      ),
                      // isStack: true,
                      isGroup: true,
                      xField: "date",
                      yField: "value",
                      seriesField: "subCategory",
                      // groupField: "category",
                      // seriesField: "subCategory",
                      label: {
                        position: "bottom",
                        layout: [
                          {
                            type: "interval-adjust-position",
                          },
                          {
                            type: "interval-hide-overlap",
                          },
                          {
                            type: "adjust-color",
                          },
                        ],
                      },
                      slider: {
                        start: 0,
                        end: 1,
                      },
                      height: 390,
                      onEvent: (_, event) => {
                        if (event.type === "axis:click") {
                          let dateRange = [
                            event.gEvent.target.attrs.text + "-01",
                          ];
                          dateRange[1] = moment(dateRange[0])
                            .endOf("month")
                            .toISOString()
                            .split("T")[0];
                          if (stateStore.navAble)
                            stateStore.navAble({
                              defaultSelectedKeys: ["jobSearch"],
                              routableProps: {
                                state: {
                                  activeKey: "4",
                                  category: "date",
                                  date: dateRange,
                                },
                                caller: "dashboard",
                              },
                            });
                        } else if (event.type === "element:click") {
                          let dateRange = [event.data.data.date + "-01"];
                          dateRange[1] = moment(dateRange[0])
                            .endOf("month")
                            .toISOString()
                            .split("T")[0];
                          switch (event.data.data.category) {
                            case "building":
                              if (stateStore.navAble)
                                stateStore.navAble({
                                  defaultSelectedKeys: ["jobSearch"],
                                  routableProps: {
                                    state: {
                                      activeKey: "4",
                                      date: dateRange,
                                      category: "building",
                                      subCategory: event.data.data.subCategory,
                                      id: event.data.data.id,
                                    },
                                    caller: "dashboard",
                                  },
                                });
                              break;
                            case "technician":
                              if (stateStore.navAble)
                                stateStore.navAble({
                                  defaultSelectedKeys: ["jobSearch"],
                                  routableProps: {
                                    state: {
                                      activeKey: "4",
                                      date: dateRange,
                                      category: "technician",
                                      subCategory: event.data.data.subCategory,
                                      id: event.data.data.id,
                                    },
                                    caller: "dashboard",
                                  },
                                });
                              break;
                            case "complaintType":
                              if (stateStore.navAble)
                                stateStore.navAble({
                                  defaultSelectedKeys: ["jobSearch"],
                                  routableProps: {
                                    state: {
                                      activeKey: "4",
                                      date: dateRange,
                                      category: "complaintType",
                                      subCategory: event.data.data.subCategory,
                                      id: event.data.data.id,
                                    },
                                    caller: "dashboard",
                                  },
                                });
                              break;
                            case "priority":
                              if (stateStore.navAble)
                                stateStore.navAble({
                                  defaultSelectedKeys: ["jobSearch"],
                                  routableProps: {
                                    state: {
                                      activeKey: "4",
                                      date: dateRange,
                                      category: "priority",
                                      subCategory: event.data.data.subCategory,
                                      id: event.data.data.id,
                                    },
                                    caller: "dashboard",
                                  },
                                });
                              break;
                            case "read":
                            case "status":
                              if (stateStore.navAble)
                                stateStore.navAble({
                                  defaultSelectedKeys: ["jobSearch"],
                                  routableProps: {
                                    state: {
                                      activeKey: {
                                        Unread: "0",
                                        Read: "1",
                                        Open: "1",
                                        Closed: "3",
                                      }[event.data.data.subCategory],
                                      date: dateRange,
                                      category: event.data.data.category,
                                      subCategory: event.data.data.subCategory,
                                      id: event.data.data.id,
                                    },
                                    caller: "dashboard",
                                  },
                                });
                              break;
                            default:
                              break;
                          }
                        }
                      },
                    }}
                  />
                ) : (
                  <Empty />
                )}
              </Card>
            ) : null}
          </Col>
          <Col span={8} xs={24} sm={24} md={12} lg={6}>
            <Row gutter={[20, 50]}>
              <Col span={8} xs={12} sm={12} md={24} lg={24}>
                {this.state.complaintData.dataIsLoading &&
                !this.state.complaintData.solvedPercent ? (
                  <Skeleton.Button
                    active
                    block={true}
                    style={{
                      // width: window.innerWidth / 3 - 40,
                      width:
                        window.outerWidth >= 992
                          ? window.innerWidth / 4 - 50
                          : window.outerWidth >= 768
                          ? window.innerWidth / 2 - 50
                          : window.innerWidth / 2 - 50,
                      height: (window.innerHeight - 50) / 2 / 2 - 25,
                      // borderRadius: 20,
                    }}
                  />
                ) : this.state.complaintData.list.length ? (
                  <Tooltip title="Percentage of total solved complaints">
                    <Card
                      style={{
                        width: "100%",
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                        transition: "0.3s",
                        // borderRadius: 20,
                      }}
                      headStyle={{
                        textAlign: "center",
                        height: "30px",
                        minHeight: "30px",
                        padding: 0,
                      }}
                      bodyStyle={{
                        padding: 10,
                        paddingBottom: 0,
                        borderBottom: "0px solid",
                        textAlign: "center",
                      }}
                      title={"Solved"}
                    >
                      <Liquid
                        {...{
                          percent: this.state.complaintData.solvedPercent / 100,
                          outline: {
                            border: 4,
                            distance: 8,
                          },
                          theme: {
                            styleSheet: {
                              brandColor:
                                this.state.complaintData.solvedPercent < 50
                                  ? "#FAAD14"
                                  : this.state.complaintData.solvedPercent > 80
                                  ? "#a0d911"
                                  : undefined,
                            },
                          },
                          wave: {
                            length: 128,
                          },
                          width: 150,
                          height: 150,
                        }}
                      />
                    </Card>
                  </Tooltip>
                ) : null}
              </Col>
              <Col span={8} xs={12} sm={12} md={24} lg={24}>
                {this.state.complaintData.dataIsLoading &&
                !this.state.complaintData.solvedRatio ? (
                  <Skeleton.Button
                    active
                    block={true}
                    style={{
                      // width: window.innerWidth / 3 - 40,
                      width:
                        window.outerWidth >= 992
                          ? window.innerWidth / 4 - 50
                          : window.outerWidth >= 768
                          ? window.innerWidth / 2 - 50
                          : window.innerWidth / 2 - 50,
                      height: (window.innerHeight - 50) / 2 / 2 - 25,
                      // borderRadius: 20,
                    }}
                  />
                ) : this.state.complaintData.list.length ? (
                  <Tooltip title="Percentage of solved in average per month">
                    <Card
                      style={{
                        width: "100%",
                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                        transition: "0.3s",
                        // borderRadius: 20,
                      }}
                      headStyle={{
                        textAlign: "center",
                        height: "30px",
                        minHeight: "30px",
                        padding: 0,
                      }}
                      bodyStyle={{
                        padding: 10,
                        paddingBottom: 0,
                        borderBottom: "0px solid",
                        textAlign: "center",
                      }}
                      title={"Average Solved / Month"}
                    >
                      <Gauge
                        {...{
                          percent: this.state.complaintData.solvedRatio / 100,
                          range: {
                            ticks: [0, 1],
                            color: ["l(0) 0:#F4664A 0.5:#FAAD14 1:#30BF78"],
                          },
                          indicator: {
                            shape: "custom-gauge-indicator",
                            pointer: {
                              style: {
                                stroke: "#D0D0D0",
                                lineWidth: 1,
                                fill: "#D0D0D0",
                              },
                            },
                          },
                          statistic: {
                            title: {
                              formatter: ({ percent }) => {
                                if (percent < 50) {
                                  return (
                                    parseFloat(percent * 100).toFixed(2) + "%"
                                  );
                                }
                                if (percent < 80) {
                                  return (
                                    parseFloat(percent * 100).toFixed(2) + "%"
                                  );
                                }
                                return (
                                  parseFloat(percent * 100).toFixed(2) + "%"
                                );
                              },
                              style: ({ percent }) => {
                                return {
                                  fontSize: "14px",
                                  lineHeight: 1,
                                  color:
                                    percent < 0.5
                                      ? "#F4664A"
                                      : percent < 0.8
                                      ? "#faad14"
                                      : "#30bf78",
                                };
                              },
                            },
                          },
                          width: 150,
                          height: 150,
                        }}
                      />
                    </Card>
                  </Tooltip>
                ) : null}
              </Col>
            </Row>
          </Col>
          <Col span={8} xs={24} sm={24} md={24} lg={6}>
            {this.state.complaintData.dataIsLoading && // this
            !this.state.complaintData.list.length ? (
              <Skeleton.Button
                active
                block={true}
                style={{
                  // width: window.innerWidth / 3 - 40,
                  width:
                    window.outerWidth >= 992
                      ? window.innerWidth / 4 - 50
                      : window.outerWidth >= 768
                      ? window.innerWidth - 90
                      : window.innerWidth - 90,
                  height:
                    window.innerWidth < 992
                      ? 190
                      : (window.innerHeight - 50) / 2,
                  // borderRadius: 20,
                }}
              />
            ) : this.state.complaintData.list.length ? (
              <Card
                style={{
                  width: "100%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  maxHeight: 432,
                  // borderRadius: 20,
                }}
                headStyle={{
                  textAlign: "center",
                  height: "30px",
                  minHeight: "30px",
                  padding: 0,
                }}
                bodyStyle={{
                  padding: 10,
                  paddingBottom: 0,
                  borderBottom: "0px solid",
                  textAlign: "center",
                }}
                // title={"Solve Ratio"}
              >
                {/* <Row gutter={[30, 55]}>
                  <Col span={24} xs={12} sm={12} md={12} lg={24}>
                    <Tooltip title="Number of closed complaint(s) till now">
                      <Statistic
                        title="Closed Complaints"
                        value={this.state.complaintData.noOfSolvedComplaints}
                      />
                    </Tooltip>
                  </Col>
                  <Col span={24} xs={12} sm={12} md={12} lg={24}>
                    <Tooltip title="Number of pending complaint(s) till now">
                      <Statistic
                        title="Pending Complaints"
                        value={this.state.complaintData.noOfPendingComplaints}
                        valueStyle={{
                          color:
                            this.state.complaintData.noOfPendingComplaints < 5
                              ? "#3f8600"
                              : this.state.complaintData
                                  .noOfPendingComplaints === 5
                              ? "#d4b106"
                              : "#cf1322",
                        }}
                      />
                    </Tooltip>
                  </Col>
                  <Col span={24} xs={12} sm={12} md={12} lg={24}>
                    <Tooltip title="Number of pending critical priority complaint(s)">
                      <Statistic
                        title="Critical Priorities"
                        value={
                          this.state.complaintData.noOfPendingHighPriorities
                        }
                        valueStyle={{
                          color:
                            this.state.complaintData.noOfPendingHighPriorities <
                            3
                              ? "#3f8600"
                              : this.state.complaintData
                                  .noOfPendingHighPriorities === 3
                              ? "#d4b106"
                              : "#cf1322",
                        }}
                      />
                    </Tooltip>
                  </Col>
                  <Col span={24} xs={12} sm={12} md={12} lg={24}>
                    <Tooltip title="Number of days in average for a complaint to get solved">
                      <Statistic
                        precision={2}
                        title="Average Day(s)"
                        value={this.state.complaintData.noOfAverageDays}
                        valueStyle={{
                          color:
                            this.state.complaintData.noOfAverageDays < 3
                              ? "#3f8600"
                              : this.state.complaintData.noOfAverageDays === 3
                              ? "#d4b106"
                              : "#cf1322",
                        }}
                      />
                    </Tooltip>
                  </Col>
                </Row> */}
                <RadialBar
                  {...{
                    data: [
                      {
                        name: "Pending",
                        value: this.state.complaintData.noOfPendingComplaints,
                      },
                      {
                        name: "Closed",
                        value: this.state.complaintData.noOfSolvedComplaints,
                      },
                      {
                        name: "Total",
                        value:
                          this.state.complaintData.noOfPendingComplaints +
                          this.state.complaintData.noOfSolvedComplaints,
                      },
                    ],
                    xField: "name",
                    yField: "value",
                    maxAngle: 300,
                    radius: 1,
                    innerRadius: 0.2,
                    type: "line",
                    height: 432,
                    tooltip: {
                      formatter: (datum) => {
                        return {
                          name: "Value",
                          value: datum.value,
                        };
                      },
                    },
                    colorField: "name",
                    color: ({ name }) => {
                      if (name === "Pending") {
                        return "#d1b602";
                      } else if (name === "Closed") {
                        return "green";
                      }

                      return "#2194ff";
                    },
                    barBackground: {},
                    barStyle: { lineWidth: 6 },
                    label: {},
                    onEvent: (_, event) => {
                      if (event.type === "element:click") {
                        let dateRange = [...this.state.complaintData.dateRange];
                        if (dateRange[0]) {
                          dateRange[0] = dateRange[0]
                            .add(1, "day")
                            .toISOString()
                            .split("T")[0];
                        }
                        if (dateRange[1]) {
                          dateRange[1] = dateRange[1]
                            .endOf("month")
                            .toISOString()
                            .split("T")[0];
                        }
                        switch (event.data.data.name) {
                          case "Total":
                            if (stateStore.navAble)
                              stateStore.navAble({
                                defaultSelectedKeys: ["jobSearch"],
                                routableProps: {
                                  state: {
                                    activeKey: "4",
                                    category: "total",
                                    date: dateRange,
                                  },
                                  caller: "dashboard",
                                },
                              });
                            break;
                          case "Pending":
                            if (stateStore.navAble)
                              stateStore.navAble({
                                defaultSelectedKeys: ["jobSearch"],
                                routableProps: {
                                  state: {
                                    activeKey: "1",
                                    category: "total",
                                    date: dateRange,
                                  },
                                  caller: "dashboard",
                                },
                              });
                            break;
                          case "Closed":
                            if (stateStore.navAble)
                              stateStore.navAble({
                                defaultSelectedKeys: ["jobSearch"],
                                routableProps: {
                                  state: {
                                    activeKey: "3",
                                    category: "total",
                                    date: dateRange,
                                  },
                                  caller: "dashboard",
                                },
                              });
                            break;
                          default:
                            break;
                        }
                      }
                    },
                  }}
                />
              </Card>
            ) : null}
          </Col>
          <Col span={8} xs={24} sm={24} md={12} lg={9}></Col>
        </Row>
      </Spin>
    );
  }
}

export default withRouter(EmployeeHome);
